import React, { useEffect } from "react"
import { useRenderStyling } from "lib/hooks/useRenderStyling"
import { parseContent, parseContentGroup } from "./utils"

export default function SummaryBlockRender({ renderPkg }:{ renderPkg?:any }){

  const logoStyle = useRenderStyling("flex justify-end mt-3 w-full mb-4 ml-10", "styleObj")

  const settings = renderPkg.dispute.elements.find((setting:any) => setting.refstr === "summary_block").settings || {}

  const blockStyling = useRenderStyling("w-full flex justify-end", "styleObj")
  const outerStyling = useRenderStyling("bg-neutral-200 border border-solid border-neutral-700 rounded-md flex flex-col justify-center pl-2 pr-4 pb-2 mr-2", "styleObj")
  const amtStyling = useRenderStyling("w-full text-2xl font-extrabold border-b-4 border-b-solid border-b-neutral-800 mb-3", "styleObj")
  const reasonCodeStyling = useRenderStyling("w-full flex flex-col gap-1 leading-tight", "styleObj")
  const descriptionStyling = useRenderStyling("whitespace-nowrap", "styleObj")

  const parseProps = { clientDataObj: renderPkg.clientdata, apiData: renderPkg.apidata}

  return (
    <div id="mm-summary-block" { ...blockStyling}>
      <div { ...outerStyling}>
        <div {...amtStyling}>
          Amount: { parseContent({content: "[[rp.Chargeback.Amount]]", ...parseProps}).result }
        </div>
        <div {...reasonCodeStyling}>
          <span>Reason Code: { parseContent({ content: "[[rp.ReasonCode]]", ...parseProps}).result }</span>
          { parseContent({content: "[[rp.ReasonCodeDescription]]", ...parseProps}).result !== "rp.ReasonCodeDescription" && (
            <span {...descriptionStyling}>Reason Description: { parseContent({content: "[[rp.ReasonCodeDescription]]", ...parseProps}).result }</span>
          )}
        </div>
      </div>
    </div>
  )
}